export default "__VITE_ASSET__BVNe$f6V__"